<template>
    <div class="lawlex-custom-card">
      <div class="user-not-registered-wraper">
        <img src="@/img/lawlex_lock.svg"/>
        <div>
          <span v-html="$t(messageKey)"></span> <a class="link" @click="handleClick" :href="helpLink">{{ $t('dashboard_no_access_here') }}</a>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { createNamespacedHelpers } from "vuex";
  const { mapActions } = createNamespacedHelpers('quickviews');
  export default {
    name: "NoAccess",
    props: {
      type: {
        type: String,
        default: 'regulatory'
      }
    },
    methods: {
    ...mapActions(['addToIpdLog']),
    handleClick() {
        this.addToIpdLog({
          moduleName: 'Dashboard - Lawlex - NoAccess',
          linkClicked: this.helpLink
        });
      }
    },
    computed: {
      messageKey() {
        switch (this.type) {
          case 'recent_search':
            return 'dashboard_no_access_message_recent_search';
          case 'saved_search':
            return 'dashboard_no_access_message_saved_search';
          default:
            return 'dashboard_no_access_message_regulatory_newsfeeds';
        }
      },
      helpLink() {
        switch (this.type) {
          case 'recent_search':
            return 'https://www.intertekinform.com/en-au/regulatory-management/';
          case 'saved_search':
            return 'https://www.intertekinform.com/en-au/regulatory-management/lawlexeu-saved-searches';
          default:
            return 'https://www.intertekinform.com/en-au/regulatory-management/regulatory-newsfeeds';
        }
      }
    }
  };
  </script>
